import React from 'react'

const GeofenceEditTitle = ({ record }) => (
  <span>{record.name ? `${record.name}` : 'Geofence'}</span>
)

export default GeofenceEditTitle
